export const fieldNameCompanyName = 'companyName';
export const fieldNameCompanySelectedId = 'companySelected';
